"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeLayout = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const common_1 = require("../../../common");
const DSST001_List_Child_1 = require("../../DSS/DSST001/DSST001_List_Child");
const DSTL001_1 = require("../../DST/DSTL001");
const DSTL001_List_Child_1 = require("../../DST/DSTL001/component/DSTL001_List_Child");
const HomeLayout_Child_1 = require("./HomeLayout_Child");
const OpenTable_1 = require("./OpenTable");
const react_redux_1 = require("react-redux");
const action_1 = require("../../menu/action");
const DTST004_List_Child_1 = require("../../DST/DSTS004/DTST004_List_Child");
const account_1 = require("../account");
const classes_1 = require("../classes");
const HomeLayoutStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}

	.fext-field {
		flex: 1;
		align-items: flex-start !important;
	}

	.assignment {
		.fext-field {
			height: 100%;
			justify-content: center;

			.assignment-table {
				height: 100%;
				.table {
					height: 100%;

					.table-item-wrap {
						height: 100%;
					}
				}
			}
		}
	}

	.date,
	.creation_time {
		color: var(--color-grey, #666666);
		text-align: right;
	}
`;
const mobileStyles = (0, styled_components_1.css) `
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: var(--color-sliver, #f3f4f8);

	.line {
		background: var(--color-silver, #f3f4f8);
		flex-shrink: 0;
		width: 1px;
		position: relative;
	}
	.header-label {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.header-title {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 20px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.fext-field {
		height: 100%;
		overflow: hidden;
	}

	.main-container {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.wrap-002 {
		padding: 0 20px 24px 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;

		.container-001 {
			display: flex;
			flex-direction: row;
			gap: 26px;
			align-items: flex-start;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.home-box {
			&.conferenceReview {
				min-height: 358px;
			}
			&:not(.conferenceReview) {
				min-height: 320px;
			}
			.task-label {
				min-height: 35px;
				justify-content: center;
			}
			.fext-field > * {
				width: 100%;
			}
			flex: 1;
			background: var(--color-white, #ffffff);
			border-radius: 16px;
			padding: 20px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			overflow: hidden;
			gap: 4px;
		}
	}

	.home {
		.box-wrap {
			background-color: transparent;
			.box-wrap-item {
				background: var(--color-silver, #f3f4f8);
			}
		}
	}

	.more_detail {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		line-height: 32px;
		letter-spacing: -0.02em;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		.overText {
			min-width: unset;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	width: 100%;
	height: max-content;
	background-color: var(--color-sliver, #f3f4f8);

	.line {
		background: var(--color-silver, #f3f4f8);
		flex-shrink: 0;
		width: 1px;
		position: relative;
	}

	.header-label {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.header-title {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h3-font-size, 24px);
			line-height: var(--h3-line-height, 36px);
			font-weight: var(--h3-font-weight, 700);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.header-more {
			color: var(--color-grey, #666666);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 16px;
			line-height: 32px;
			font-weight: 400;
			text-decoration: underline;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.main-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.wrap-002 {
		padding: 10px 80px 70px 80px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;

		.container-001 {
			display: flex;
			flex-direction: row;
			gap: 26px;
			align-items: flex-start;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.home-box {
			&.conferenceReview {
				min-height: 350px;
			}
			&:not(.conferenceReview) {
				min-height: 358px;
			}
			.task-label {
				min-height: 35px;
				justify-content: center;
			}
			.fext-field > * {
				width: 100%;
			}
			flex: 1;
			background: var(--color-white, #ffffff);
			border-radius: 16px;
			padding: 24px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			overflow: hidden;
		}
	}

	.home {
		.box-wrap {
			background-color: transparent;
			.box-wrap-item {
				background: var(--color-silver, #f3f4f8);
			}
		}
	}

	.more_detail {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		line-height: 32px;
		letter-spacing: -0.02em;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;

		.overText {
			min-width: 50px;
		}
	}
`;
exports.HomeLayout = react_1.default.memo(({ isTeacher }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const userId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserInfo)(state)?.id);
    const dispatch = (0, react_redux_1.useDispatch)();
    const commonItems = [
        {
            title: 'notice',
            width: undefined,
            option: {
                title: 'notice',
                data: { menu: 'notice', detail: 'list' },
                menu: 'notice',
            },
            children: react_1.default.createElement(OpenTable_1.OpenTable, { isResource: false, isHome: true }),
        },
        {
            title: 'resource',
            width: undefined,
            option: {
                title: 'learningSupportRoom_menu',
                data: { menu: 'resource', detail: 'list' },
                menu: 'learningSupportRoom',
            },
            children: react_1.default.createElement(OpenTable_1.OpenTable, { isResource: true, isHome: true }),
        },
        {
            title: 'test',
            width: undefined,
            option: {
                title: isTeacher ? 'learningManagement_menu' : 'myRoom_menu',
                data: { menu: 'test', detail: 'list' },
                menu: isTeacher ? 'learningManagement' : 'myRoom',
            },
            children: react_1.default.createElement(DSTL001_1.HomeAssignment, { isTeacher: isTeacher, isTest: true }),
        },
        {
            title: 'assignment',
            width: undefined,
            option: {
                title: isTeacher ? 'learningManagement_menu' : 'myRoom_menu',
                data: { menu: 'assignment', detail: 'list' },
                menu: isTeacher ? 'learningManagement' : 'myRoom',
            },
            children: react_1.default.createElement(DSTL001_List_Child_1.AssignmentTable, { isTeacher: isTeacher, isTest: false, isHome: true }),
        },
        {
            title: isTeacher ? 'qnaWaitingSimple' : 'myQnASimple',
            width: 750,
            option: {
                title: 'assignment_menu',
                data: { menu: 'qna', detail: 'list' },
                menu: 'learningSupportRoom',
            },
            children: react_1.default.createElement(DTST004_List_Child_1.QnAListTable, { isTeacher: isTeacher, isHome: true }),
        },
        {
            title: 'conferenceReview',
            width: undefined,
            option: {
                title: 'reservation_menu',
                data: { menu: 'replay', detail: 'list' },
                menu: isTeacher ? 'liveRoom' : 'myRoom',
            },
            children: react_1.default.createElement(DSST001_List_Child_1.ReviewClassList, { isHome: true }),
        },
    ];
    const generateTableList = deviceType => {
        const indexes = {
            notice: 0,
            resource: 1,
            qna: 4,
            test: 2,
            assignment: 3,
            replay: 5,
        };
        // commonItems를 classesMenu에 있는 항목으로 필터링
        const filteredItems = Object.entries(indexes)
            .filter(([key]) => !hiddenMenus.includes(key))
            .reduce((acc, [key, index]) => {
            acc[index] = commonItems[index];
            return acc;
        }, {});
        // deviceType에 따라 테이블 리스트 생성
        switch (deviceType) {
            case 'desktop':
                return [
                    [filteredItems[indexes.notice], filteredItems[indexes.resource]].filter(Boolean),
                    [
                        filteredItems[indexes.test],
                        filteredItems[indexes.assignment],
                        filteredItems[indexes.qna],
                    ].filter(Boolean),
                    // isTeacher && [filteredItems[indexes.replay]].filter(Boolean),
                ].filter(Boolean);
            case 'tablet':
                return [
                    [filteredItems[indexes.notice], filteredItems[indexes.resource]].filter(Boolean),
                    [filteredItems[indexes.test]].filter(Boolean),
                    [filteredItems[indexes.assignment]].filter(Boolean),
                    [filteredItems[indexes.qna]].filter(Boolean),
                    // isTeacher && [filteredItems[indexes.replay]].filter(Boolean),
                ].filter(Boolean);
            default: // mobile
                return [
                    [filteredItems[indexes.notice]].filter(Boolean),
                    [filteredItems[indexes.resource]].filter(Boolean),
                    [filteredItems[indexes.test]].filter(Boolean),
                    [filteredItems[indexes.assignment]].filter(Boolean),
                    [filteredItems[indexes.qna]].filter(Boolean),
                    // isTeacher && [filteredItems[indexes.replay]].filter(Boolean),
                ].filter(Boolean);
        }
    };
    const table_list = (0, react_1.useMemo)(() => {
        const deviceType = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile';
        return generateTableList(deviceType);
    }, [isDesktop, isTablet, hiddenMenus]);
    return (react_1.default.createElement(HomeLayoutStyled, { "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "main-container" },
            react_1.default.createElement(HomeLayout_Child_1.Profile, null)),
        react_1.default.createElement("div", { className: "wrap-002" },
            !isTeacher && userId && (react_1.default.createElement(HomeLayout_Child_1.HomeStudyReport, { userId: userId, hiddenMenus: hiddenMenus, onMore: () => {
                    dispatch((0, action_1.updateMenu)('myRoom', {
                        menu: 'gradeCard',
                        detail: 'list',
                    }));
                } })),
            table_list.map((items, index) => (react_1.default.createElement("div", { className: 'container-001', key: index }, items.map(item => (react_1.default.createElement(HomeBox, { key: item.title, title: item.title, style: { minWidth: item.width ? `${item.width}` : undefined }, onMore: () => {
                    if (!item.option)
                        return;
                    dispatch((0, action_1.updateMenu)(item.option.menu, item.option.data, undefined));
                }, isReplay: item.title === 'conferenceReview' ? true : false }, item.children)))))))));
});
const HomeBox = react_1.default.memo(({ title, style, onMore, children, isReplay, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("div", { className: `home-box field-global-001 ${title}`, style: style },
        react_1.default.createElement("div", { className: "header-label" },
            react_1.default.createElement("div", { className: "header-title" }, t(`menu.${title}`)),
            !isReplay && react_1.default.createElement(common_1.Button, { className: "more_detail", text: "\uB354\uBCF4\uAE30", onClick: onMore })),
        react_1.default.createElement("div", { className: "fext-field" }, children)));
});
